module.exports = __webpack_public_path__ + "static/media/service-slider.cbadf852.jpg";